module.exports = __webpack_public_path__ + "img/bg1 (3).361ee6aa.jpg";